import { gql } from "graphql-tag"

import { DEFAULTS } from "../shared/utils/defaults"

const typeUser = gql`
  enum Role {
    ADMIN
    REGIONAL_LEAD
    IDM_USER
    IDM_DISPONENT
    IDM_LEAD
    IDM_THEKE
    ADM
    CUSTOMER
    ADM_GVL
    IDM_SPRINGER,
    IDM_SPRINGER_LEAD
    IDM_PROCUREMENT
  }

  type AdmFields {
    admNumbers: [String]
    regionalLeadNumbers: [String]
    amountOfCustomers: Int
    amountOfCustomersWithSales: Int
    customerWithSalesGrowth: Int
    revenueTarget: Float
    allowReservationMutation: Boolean
    allowAllCustomerSearch: Boolean
    allowDocumentMutation: Boolean
    enableAssistant: Boolean
    altBranchCustomerSearch: String
  }

  type CustomerBaseInfo {
    admNumber: String
    amountOfCustomers: Int
    amountOfCustomersWithSales: Int
    customerWithSalesGrowth: Int
    revenueTarget: Float
    name: String
  }

  type UserBranch {
    id: ID
    title: String
  }

  type User {
    id: ID
    firstName: String
    lastName: String
    customerGroup: JSON
    customAdmFields: AdmFields
    role: Role
    employeeNumber: String
    branchId: String
  }

  type UserPasswordReset {
    id: ID
    value: String
    expiresAt: DateTime
  }

  type CustomerBases {
    limit: Int
    offset: Int
    count: Int
    total: Int
    items: [CustomerBaseInfo]
  }

  type Permission {
    permissionGranted: Boolean
  }

  type Query {
    admUser(admNumber: String): Customer
    checkPermission(domainObject: String, operation: String): Permission
    userAssignedBranch(lang: String = "", cdn: Boolean = true): UserBranch

    customerBases (
      offset: Int = ${DEFAULTS.QUERY.OFFSET}
      limit: Int = ${DEFAULTS.QUERY.LIMIT}
      sort: Sort = {
                orderBy: "lastName",
                direction: "asc"
            }
      ): CustomerBases
  }

  type Mutation {
    signInUser(email: EmailAddress, password: String): User
  }
`

export { typeUser }

export default typeUser
